import React from 'react';
import {Dialog, DialogActions, DialogContent, Tooltip,} from '@mui/material';
import {ButtonTypography, GreyOutlinedButton, PrimaryContainedButton} from '../Buttons/buttons';
import {EditDialogTitle, PaperComponent} from '../EditDialog/EditDialog';

interface LagreEndringerDialogProps {
    title: string;
    children?: any;
    open: boolean;
    isValid: boolean;
    ignorere: () => void;
    avbryt: () => void;
    onClose: () => void;
    lagre: () => void;
}

export const LagreEndringer = (props: LagreEndringerDialogProps) => {
    const {title, children, open, onClose, lagre, ignorere, isValid} = props;
    return (
        <Dialog
            open={open}
            PaperComponent={PaperComponent}
            onClose={onClose}
            aria-labelledby='confirm-dialog'
        >
            <EditDialogTitle
                id="draggable-dialog-title"
                style={{fontSize: '16px', paddingTop: 11, paddingBottom: 11}}
            >
                {title}
            </EditDialogTitle>
            {!children ? <></> : <DialogContent>{children}</DialogContent>}
            <DialogActions>
                <Tooltip title='Endringene blir ikke lagret'>
                    <GreyOutlinedButton
                        test-id={'lagreEndringer-avbryt-btn'}
                        onClick={ignorere}
                    >
                        <ButtonTypography>Nei</ButtonTypography>
                    </GreyOutlinedButton>
                </Tooltip>
                <PrimaryContainedButton
                    disabled={!isValid}
                    onClick={lagre}>
                    <ButtonTypography> Ja </ButtonTypography>
                </PrimaryContainedButton>
            </DialogActions>
        </Dialog>
    );
};
